module.exports = __webpack_public_path__ + "static/media/mojiki.4f00fe52.png";